module.exports = __webpack_public_path__ + "static/media/43_B.1cd07134.png";